module.exports = __webpack_public_path__ + "img/tour-64.04b7383b.png";